import { useParams, Outlet } from '@tanstack/react-router';
import AsyncPageContainer from '_/common/components/layout/AsyncPageContainer';
import SourceSection from '_/common/components/layout/SourceSection';
import { useSourceContext } from '_/contexts/SourceContext';
import DocumentTitle from '_/hooks/DocumentTitle';
import React, { ReactElement } from 'react';

function SelectedSourceContent(): ReactElement {
  const params = useParams({ strict: false }) as Partial<{ sourceSlug: string }>;
  const sourceSlug = params.sourceSlug || '';
  // SourceContext automatically selects source from URL - no manual selection needed!
  const { selectedSource, isLoading } = useSourceContext();

  // Don't render anything for special route slugs - they're handled by other components
  if (sourceSlug === '_new') {
    return <></>;
  }

  DocumentTitle(`${selectedSource?.name} :: ${location.pathname.split('/').pop()}`);

  return (
    <AsyncPageContainer isLoading={isLoading}>
      <Outlet />
    </AsyncPageContainer>
  );
}

function SelectedSource(): ReactElement {
  return (
    <SourceSection>
      <SelectedSourceContent />
    </SourceSection>
  );
}

export default SelectedSource;
